import React from 'react';


import { Redirect, BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress, Box, Tabs, Tab } from '@mui/material';

import RemoteButton from './RemoteButton'
import FormatError from './FormatError'
import Logs from './Logs'
import  UserTable  from './UserTable'


class ProjectList extends React.PureComponent {
    state = {
        loading: true,
        projects: null,
    };

    componentDidMount() {
        this.loadProjectList();
    }

    loadProjectList() {
        fetch('/api/store/project/list').then(response => response.json())
            .then(result => {
                if (result.results) {
                    this.setState({ loading: false, projects: result.results });
                } else {
                    this.setState({ loading: false, error: result.error });
                }
            });
    }

    setPublic = (id, value) => async () => {
        const response = await fetch('/api/admin/project/set_public', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id, value
            }),
        });
        const result = await response.json();
        if (result.result === 'OK') {
            this.setState({ loading: true });
            this.loadProjectList();
        } else {
            this.setState({ error: result.error });
        }
    }

    setGreenlit = (id, value) => async () => {
        const response = await fetch('/api/admin/project/greenlit', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id, value
            }),
        });
        const result = await response.json();
        if (result.result === 'OK') {
            this.setState({ loading: true });
            this.loadProjectList();
        } else {
            this.setState({ error: result.error });
        }
    }

    render() {
        return (
            <div>
                <h2>Project List</h2>
                {
                    this.state.error && FormatError(this.state.error)
                }
                {
                    this.state.loading && "Loading..."
                }
                {
                    this.state.projects &&
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Visibility</th>
                                <th>Opertions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.projects.map(p => (
                                <tr key={p.id}>
                                    <td>
                                        {p.name}
                                    </td>
                                    <td>
                                        {p.public ? <b>public</b> : "non-public"}
                                    </td>
                                    <td>
                                        <button onClick={this.setPublic(p.id, true)}>public</button><button onClick={this.setPublic(p.id, false)}>hide</button>
                                        {!p.greenlit ?
                                            <button onClick={this.setGreenlit(p.id, true)}>greenlit</button>
                                            :
                                            <button onClick={this.setGreenlit(p.id, false)}>ungreenlit</button>}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                }
            </div>
        )
    }
}

class AssetPacksList extends React.PureComponent {
    state = {
        loading: true,
        assetPacks: null,
    };

    componentDidMount() {
        this.loadAssetPacksList();
    }

    loadAssetPacksList = async () => {
        const response = await fetch('/api/admin/assetpacks/list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: "wildsky_legacy",
                limit: 100,
            }),
        });
        const result = await response.json();
        if (result.results) {
            this.setState({ loading: false, assetPacks: result.results });
        } else {
            this.setState({ loading: false, error: result.error });
        }
    }

    deleteAssetPack = (name, version) => async () => {
        const response = await fetch('/api/admin/assetpacks/delete', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name, version
            }),
        });
        const result = await response.json();
        if (result.result === 'OK') {
            this.setState({ loading: true });
            this.loadAssetPacksList();
        } else {
            this.setState({ error: result.error });
        }
    }

    render() {
        return (
            <div>
                <h2>AssetPacks List</h2>
                {
                    this.state.error && FormatError(this.state.error)
                }
                {
                    this.state.loading && "Loading..."
                }
                {
                    this.state.assetPacks &&
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Api Version</th>
                                <th>Version</th>
                                <th>Opertions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.assetPacks.map(p => (
                                <tr key={p.id}>
                                    <td>
                                        {p.name}
                                    </td>
                                    <td>
                                        {p.apiVersion}
                                    </td>
                                    <td>
                                        {p.version}
                                    </td>
                                    <td>
                                        <button onClick={this.deleteAssetPack(p.name, p.version)}>delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                }
            </div>
        )
    }
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            {children}
          </Box>
        )}
      </div>
    );
  }
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  
class Entry extends React.PureComponent {
    state = {
        gmail: '',
        error: null,
        adding: false,
        users: [],
        tags: {},
        invitations: [],
        appConfigs: [],
        appConfigGitlabProjectIds: {},
        appConfigPlatforms: {},
        tabValue: 0,
    };

    componentDidMount() {
        this.listInvitations();
        this.listAppConfigs();
    }

    async listInvitations() {
        const response = await fetch('/api/admin/invitation/list');
        const result = await response.json();
        console.log(result);
        this.setState({ invitations: result.result.invitations });
    }

    approveInvite = id => () => {
        fetch(`/api/admin/invitation/approve`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id,
            }),
        })
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ error: result.error });
                } else {
                    this.listInvitations();
                    this.listUsers();
                }
            });
    }

    removeInvite = id => () => {
        fetch(`/api/admin/invitation/remove`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id,
            }),
        })
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ error: result.error });
                } else {
                    this.listInvitations();
                }
            });
    }

    listAppConfigs = () => {
        fetch('/api/admin/appConfig/list')
            .then(response => response.json())
            .then(result => {
                console.log(result);
                if (result.error) {
                    this.setState({ error: result.error });
                } else {
                    this.setState({ appConfigs: result.result });
                }
            })
    }

    approveAppConfig = appConfig => () => {
        fetch(`/api/admin/appConfig/approve`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: appConfig.id,
                approved: !appConfig.approved,
            }),
        })
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ error: result.error });
                } else {
                    this.listAppConfigs();
                }
            });
    }

    setAppConfigGitlabProjectId = appConfig => async () => {
        const response = await fetch(`/api/admin/appConfig/set_gitlab_project_id`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: appConfig.id,
                gitlabProjectId: this.state.appConfigGitlabProjectIds[appConfig.id],
            }),
        });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.listAppConfigs();
        }
    }

    handleGitlabProjectId = appConfig => e => {
        this.setState({ appConfigGitlabProjectIds: { ...this.state.appConfigGitlabProjectIds, [appConfig.id]: e.target.value | 0 } });
    }

    setAppConfigPlatforms = appConfig => async () => {
        const response = await fetch(`/api/admin/appConfig/set_platforms`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: appConfig.id,
                platforms: this.state.appConfigPlatforms[appConfig.id],
            }),
        });
        const result = await response.json();
        if (result.error) {
            this.setState({ error: result.error });
        } else {
            this.listAppConfigs();
        }
    }

    handlePlatforms = appConfig => e => {
        this.setState({ appConfigPlatforms: { ...this.state.appConfigPlatforms, [appConfig.id]: e.target.value } });
    }

    handleTabChange = (event, newValue) => {
        this.setState({
            tabValue: newValue
        })
    };

    render() {
        return (
        <div>
            <div>
                {this.state.error && FormatError(this.state.error)}
            </div>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={this.state.tabValue} onChange={this.handleTabChange} aria-label="basic tabs example">
                    <Tab label="Users" {...a11yProps(0)} />
                    <Tab label="App Configs" {...a11yProps(1)} />
                    <Tab label="Invites" {...a11yProps(2)} />
                    <Tab label="Projects" {...a11yProps(3)} />
                    <Tab label="AssetPacks" {...a11yProps(4)} />
                </Tabs>
            </Box>
            <TabPanel value={this.state.tabValue} index={0}>
                <UserTable data={this.state.users} client={this} />
            </TabPanel>
            <TabPanel value={this.state.tabValue} index={1}>
            <h1>App Configs</h1>
            {
                this.state.appConfigs.length > 0 &&
                <table>
                    <thead>
                        <tr>
                            <th>id</th>
                            <th>projectId</th>
                            <th>appName</th>
                            <th>packageName</th>
                            <th>gitlabProjectId</th>
                            <th>platforms</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.appConfigs.map((c, i) => (
                                <tr key={i}>
                                    <td>{c.id}</td>
                                    <td>{c.projectId}</td>
                                    <td><a href={`/manage/game/${c.projectId}/build`}>{c.appName}</a></td>
                                    <td>{c.packageName}</td>
                                    <td>
                                        {c.gitlabProjectId}
                                        <RemoteButton name="Set" onStart={this.setAppConfigGitlabProjectId(c)}>
                                            Gitlab Project ID: <input value={this.state.appConfigGitlabProjectIds[c.id] || ''} onChange={this.handleGitlabProjectId(c)} />
                                        </RemoteButton>
                                    </td>
                                    <td>
                                        {c.platforms}
                                        <RemoteButton name="Set" onStart={this.setAppConfigPlatforms(c)}>
                                            Platforms: <input value={this.state.appConfigPlatforms[c.id] || ''} onChange={this.handlePlatforms(c)} />
                                        </RemoteButton>
                                    </td>
                                    <td>
                                        <Button onClick={this.approveAppConfig(c)}>
                                            {!c.approved ? 'Approve' : 'Unapprove'}
                                        </Button>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            }
            </TabPanel>
            <TabPanel value={this.state.tabValue} index={2}>
            {
                this.state.invitations.length > 0 &&
                <table>
                    <thead>
                        <tr>
                            <th>Initiator</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Approved</th>
                            <th>Operations</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.invitations.map((invite, i) => (
                                <tr key={i}>
                                    <td>{invite.userId}</td>
                                    <td>{invite.name}</td>
                                    <td>{invite.email}</td>
                                    <td>{invite.approved}</td>
                                    <td>
                                        <Button onClick={this.approveInvite(invite.id)}>Approve</Button>
                                        <Button onClick={this.removeInvite(invite.id)}>Remove</Button>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            }
            </TabPanel>
            <TabPanel value={this.state.tabValue} index={3}>
                <ProjectList />
            </TabPanel>
            <TabPanel value={this.state.tabValue} index={4}>
                <AssetPacksList />
            </TabPanel>
        </div>)
    }
}

export default function entry(props) {
    return <Switch>
        <Route path="/admin/logs" component={Logs} />
        <Route component={Entry} />
    </Switch>;
}
